import * as React from 'react';
import bindAllOfThis from "src/utils/BindThisHelper";
import PhaserGameComponent from 'src/games/shared/phaserHelpers/PhaserGameComponent';
import { GameIntroScene } from 'src/games/PuzzleSlider/scenes/GameIntro';

interface PhaserPuzzleSliderProps {
    onComplete: () => void;

}

interface PhaserPuzzleSliderState {
}

const gameConfig: GameConfig = {
    title: "Sliding Puzzle Demo - Phaser",
    version: "0.2",
    backgroundColor: "#000000",
};

class PhaserPuzzleSlider extends React.Component<PhaserPuzzleSliderProps, PhaserPuzzleSliderState> {
    private game: Phaser.Game;
    constructor(props: PhaserPuzzleSliderProps) {
        super(props);
        bindAllOfThis(this, PhaserPuzzleSlider.prototype);
    }

    render() {
        return (<div>
            <PhaserGameComponent scenes={GameIntroScene} config={gameConfig} onComplete={this.props.onComplete} />
        </div>);
    }
}

export default PhaserPuzzleSlider;



// WEBPACK FOOTER //
// ./src/games/PuzzleSlider/Main.tsx